import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA, TEXT_SCHEMA, BUTTON_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const CONTACT_ITEM_OPTION = () => ({
  field: '',
  caption: '',
  type: '' // text, email, phone, submit, long-text
})

export const CONTACT_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'contact',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Contato'),
    subtitle: SUBTITLE_SCHEMA(),
    text: TEXT_SCHEMA(),
    bg: BG_SCHEMA(),
    buttons: [BUTTON_SCHEMA()],
    'text-position': 'left',
    'text-color': '#202020',
    'layer-color': '#FFFFFF',
    items: [CONTACT_ITEM_OPTION()]
  }
}

export const beforeParseContact = target => {
  commonBeforeParseMethod(target, ['bg'])
  if (!target.buttons) Object.assign(target, {buttons: [BUTTON_SCHEMA()]})
}

export const CONTACT_SECTION = config => ({
  schema: CONTACT_SCHEMA(config),
  beforeParse: beforeParseContact
})
